var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { IgnoreMergeFunction } from '../../helpers/default-merge-functions';
import { PropertyMapping } from '../..';
import { PropertyMappingBuilderImpl } from '../property-mapping/property-mapping-builder-impl';
var ArrayPropertyBuilderImpl = /** @class */ (function () {
    function ArrayPropertyBuilderImpl(options) {
        this.options = options;
        this.builders = new PropertyMappingBuilderImpl();
    }
    ArrayPropertyBuilderImpl.prototype.build = function () {
        var _this = this;
        var mapping = new PropertyMapping(this.options.properties);
        var deserializer = function (value) {
            var array = value[_this.options.selector];
            return array.map(function (entry) { return mapping.deserialize(entry); });
        };
        var serializer = function (model, form, value) {
            console.error('Not yet implemented');
            // const array = model[this.options.selector] as any[]
            // const handledMap: Record<any, any> = {}
            //
            // for (const entry of value) {
            //   const original = array.find(
            //     _ => _[this.options.mergeKey!] === entry[this.options.mergeKey!]
            //   )
            //
            //   if (original != null) {
            //     mapping.serialize(original, entry)
            //
            //     handledMap[]
            //   } else {
            //   }
            // }
            //
            // const serialized = mapping.serialize(model, value)
            //
            // // Transport the properties of the serialized object into the original object
            // for (let key in serialized) {
            //   if (serialized.hasOwnProperty(key)) {
            //     model[key] = serialized[key]
            //   }
            // }
        };
        return {
            deserializer: this.options.deserializer || deserializer,
            initialValue: this.options.initialValue,
            mergeKey: this.options.mergeKey,
            name: this.options.name,
            normaliseInput: this.options.normaliseInput,
            properties: this.options.properties,
            selector: this.options.selector,
            serializer: this.options.serializer || serializer,
            type: 'array',
        };
    };
    ArrayPropertyBuilderImpl.prototype.defaultValue = function (defaultValue) {
        return this.with({
            defaultValue: defaultValue,
        });
    };
    ArrayPropertyBuilderImpl.prototype.deserializeWith = function (deserializer, predicate) {
        if (predicate === void 0) { predicate = true; }
        return this.with({
            deserializer: deserializer,
        }, predicate);
    };
    ArrayPropertyBuilderImpl.prototype.ignore = function () {
        return this.with({
            serializer: IgnoreMergeFunction,
        });
    };
    ArrayPropertyBuilderImpl.prototype.initializeWith = function (initialValue) {
        return this.with({
            initialValue: initialValue,
        });
    };
    ArrayPropertyBuilderImpl.prototype.mergeWith = function (mergeKey) {
        return this.with({
            mergeKey: mergeKey,
        });
    };
    ArrayPropertyBuilderImpl.prototype.properties = function (builderFunction) {
        var properties = [];
        // Get the property mapping
        var propertyMapping = builderFunction(this.builders);
        for (var key in propertyMapping) {
            if (propertyMapping.hasOwnProperty(key)) {
                var property = propertyMapping[key].build();
                properties.push(property);
            }
        }
        return this.with({
            properties: properties,
        });
    };
    ArrayPropertyBuilderImpl.prototype.serializeWith = function (serializer, predicate) {
        if (predicate === void 0) { predicate = true; }
        return this.with({
            serializer: serializer,
        }, predicate);
    };
    ArrayPropertyBuilderImpl.prototype.with = function (newOptions, predicate) {
        if (predicate === void 0) { predicate = true; }
        var maybeNewBuilder = this;
        if (predicate) {
            maybeNewBuilder = new ArrayPropertyBuilderImpl(__assign(__assign({}, this.options), newOptions));
        }
        return maybeNewBuilder;
    };
    return ArrayPropertyBuilderImpl;
}());
export { ArrayPropertyBuilderImpl };
//# sourceMappingURL=array-property-builder-impl.js.map